<template>
	<div>
		<p class="text-center mt-2" v-show="!idmateria">
			Conoce cuándo y dónde un profesor está disponible para consultas.
		</p>

		<v-slide-x-reverse-transition hide-on-leave>
			<!-- LISTADO DE MATERIAS -->
			<div v-show="!idmateria">
				<v-divider></v-divider>
				<v-list class="ml-3 mr-3">
					<v-list-item
						v-for="(hor, i) in horarios"
						:key="i"
						class="materias."
						:to="{ name: 'HoraConsulta', params: { idmateria: i } }"
					>
						<v-list-item-content>
							<v-list-item-title>{{ hor.materia }} </v-list-item-title>
						</v-list-item-content>
						<v-list-item-icon>
							<v-icon color="primary" size="35">mdi-chevron-right</v-icon>
						</v-list-item-icon>
					</v-list-item>
				</v-list>
				<v-divider></v-divider>
			</div>
		</v-slide-x-reverse-transition>

		<!-- LISTADO DE HORARIOS -->
		<v-slide-x-reverse-transition leave-absolute hide-on-leave>
			<div v-if="horarios[idmateria]">
				<v-container fluid>
					<v-row dense>
						<v-col
							v-for="(consulta, i) in horarios[idmateria].consultas"
							:key="i"
							cols="12"
							md="4"
						>
							<v-card>
								<v-card-title>{{ consulta.profesor }}</v-card-title>
								<v-card-subtitle
									><b>Lugar: </b>{{ consulta.lugar }}</v-card-subtitle
								>
								<v-card-text class="black--text">
									<div
										v-for="(dia, i) in consulta.horario"
										v-bind:key="`dia-${i}`"
									>
										<div v-if="dia[0]">
											<b> {{ getDiaSemana(i) }} </b>
											<ul>
												<div
													v-for="(hora, j) in dia"
													v-bind:key="`hora-${i}-${j}`"
												>
													De {{ hora[0] }} a {{ hora[1] }}
												</div>
											</ul>
										</div>
									</div>
								</v-card-text>
							</v-card>
						</v-col>
					</v-row>
				</v-container>
			</div>
		</v-slide-x-reverse-transition>

		<!-- NADA QUE MOSTRAR -->
		<nothing v-show="nothingToShow || (!horarios[idmateria] && idmateria)"></nothing>

		<!-- LOADING -->
		<v-overlay :value="loading">
			<v-progress-circular indeterminate size="64"></v-progress-circular>
		</v-overlay>
	</div>
</template>

<script>
import { CONSULTAS_API } from "../apiConfig";
import Nothing from "../components/Nothing";
import { getDataModule } from "../db_save";
import store from "../store/index";

export default {
	props: ["idmateria"],
	components: { Nothing },
	data: () => ({
		datos: [],
		horarios: {},
		nothingToShow: false,
		loading: true
	}),
	created() {
		if (this.idmateria) {
			store.commit("setNombreVista", this.idmateria);
		}
		this.getHorariosConsulta();
	},
	watch: {
		$route(to) {
			store.commit("setNombreVista", this.idmateria ? this.idmateria : to.meta.nombre);
			//console.warn("CAMBIO ", this.idmateria);
		}
	},
	methods: {
		getHorariosConsulta() {
			//console.log("Get HorariosConsulta ", CONSULTAS_API);

			getDataModule("consulta", 1000 * 60 * 10, CONSULTAS_API)
				.then(consultas => {
					//console.log("HorariosConsulta: ", consultas);
					if (consultas.length > 0) {
						this.datos = consultas;
						this.clasificarMaterias();
					} else {
						this.datos = [];
						this.nothingToShow = true;
					}
				})
				.catch(e => {
					console.error("Error ", e);
				})
				.finally(() => {
					this.loading = false;
				});
		},
		clasificarMaterias() {
			let consulta = {};

			this.datos.forEach(hor => {
				if (!consulta[hor.materia]) {
					//No existe
					this.$set(consulta, hor.materia, {
						materia: hor.materia,
						consultas: []
					});
				}
				consulta[hor.materia].consultas.push(hor);
			});

			this.horarios = consulta;
		},
		getDiaSemana(num) {
			let semana = ["Lunes", "Martes", "Miercoles", "Jueves", "Viernes"];
			return semana[num];
		}
	}
};
</script>

<style>
.materias {
	box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
}
</style>
